import { FixedTextInputSize, TextInput } from "../../../components/TextInput";
import { IBilling } from "../../../types/billings";
import { Weight } from "../../../types/weights";

import styles from "./BillingWasteWeightInput.module.scss";

interface BillingWasteWeightInputProps {
  label: string;
  value: IBilling["expectedWasteAmount"];
  onChange: (value: IBilling["expectedWasteAmount"]) => void;
  isDisabled?: boolean;
}

export const BillingWasteWeightInput: React.FC<BillingWasteWeightInputProps> = ({
  label,
  value,
  onChange,
  isDisabled = false,
}) => {
  return (
    <div className={styles.container}>
      <p className={styles.text}>{label}</p>
      <TextInput
        type="number"
        value={value}
        isDisabled={isDisabled}
        fixedSize={FixedTextInputSize.fixedSm}
        endItem={<div className={styles.unit}>{Weight.Kg}</div>}
        onChange={(e) => {
          onChange(e.target.value);
        }}
      />
    </div>
  );
};
